import { Form, Input, Modal, Popconfirm, Radio, Tooltip, message } from 'antd';
import 'moment/locale/es';
import { useAuth } from '../../../../../../store/AuthContext/AuthContext';
import { authFetch } from '../../../../../../common/request/authFetch';
import { SENTIMENT_ICONS } from '../Label';
import { DeleteOutlined } from '@ant-design/icons';
import moment from 'moment';

const readonlyInputStyle = {
	color: 'rgba(0, 0, 0, 0.85)',
	background: '#f5f5f5',
	cursor: 'default',
};

export const EditLabelModal = (props: {label: any, reviewId: string, onChange: any, onFinish: any}) => {

	const [form] = Form.useForm();
	const { projectGroup } = useAuth();	

	const onFormFinish = async (values: any) => {

		const data = {
			...values,
            reviewId: props.reviewId,
            category: props.label.category,
            name: props.label.label
        };
 
		await authFetch(`${process.env.REACT_APP_API}/projects/${projectGroup.project}/${projectGroup.group}/comments/labels`, { method: 'POST', data: data })
        .then((ok: boolean) => {	
			if (ok) {
				props.onChange();
            } else {
                message.error("Error al intentar editar la etiqueta", 3);
            }
        })
	}

	const removeLabel = async (reviewId: string, label: string, category: string) => {

        const data = {
            reviewId: reviewId,            
            name: label,
            category: category
          };

        await authFetch(`${process.env.REACT_APP_API}/projects/${projectGroup.project}/${projectGroup.group}/comments/labels`,{ method: 'DELETE', data})
            .then((ok: boolean) => {
                if (ok) {
                    message.success('Etiqueta borrada de forma satisfactoria', 3);
                    props.onChange();                 
                } else {
                    message.error('Problema al borrar la etiqueta', 3);
                }
            })
        }    

	return (

		<Modal open={true} onOk={() => form.submit()} onCancel={props.onFinish} afterClose={form.resetFields}>

			<h2>Editar sentimiento</h2>
            <span style={{display:'flex', justifyContent:'right'}}>
                <Popconfirm title="Confirmar eliminación" onConfirm={() => removeLabel(props.reviewId, props.label.label, props.label.category)}>
                    <div style={{color:'dodgerblue', cursor:'pointer'}}><DeleteOutlined /> Borrar Etiqueta</div>
                </Popconfirm>			
            </span>
            <br/>
			<Form layout='vertical' form={form} onFinish={onFormFinish} initialValues={{sentiment: props.label.sentiment}}>
				<Form.Item label='Categoría'>
					<Input value={props.label.category} disabled style={readonlyInputStyle} />
				</Form.Item>
				<Form.Item label='Etiqueta'>
					<Input value={props.label.label} disabled style={readonlyInputStyle} />
				</Form.Item>
				<Form.Item					
					name='sentiment'
					label='Sentimiento'>
					<Radio.Group>
						<Radio style={{fontSize:'24px'}} value={'NEGATIVE'}>{SENTIMENT_ICONS['NEGATIVE']}</Radio>
						<Radio style={{fontSize:'24px'}} value={'NEUTRAL'}>{SENTIMENT_ICONS['NEUTRAL']}</Radio>
						<Radio style={{fontSize:'24px'}} value={'POSITIVE'}>{SENTIMENT_ICONS['POSITIVE']}</Radio>
					</Radio.Group>
				</Form.Item>												
			</Form>	
            {props.label.created && <span style={{display:'flex', justifyContent:'right'}}>
                <Tooltip title={<small>{moment.utc(props.label.created).format('llll')}</small>}>
                    {props.label.manual ? <i style={{color:'lightgrey'}}>Etiqueta creada manualmente</i> : <i style={{color:'slategrey'}}>Etiqueta creada automática</i>}
                </Tooltip>		
            </span>}
		</Modal>
	)
}
